import {ApiReviewsResponse, ReviewsResponse} from '../types'

const TRUSTPILOT_REVIEWS_URL = 'https://www.trustpilot.com/reviews'

export const addReviewLinks = (
  response: ApiReviewsResponse
): ReviewsResponse => ({
  ...response,
  reviews: response.reviews.map(review => ({
    ...review,
    reviewLink: `${TRUSTPILOT_REVIEWS_URL}/${review.id}`
  }))
})
